interface IdTokenClaims {
  roles?: string[];
}

export interface TokenResponse {
  idTokenClaims: IdTokenClaims;
}

export function hasAdminRoles(res: TokenResponse): boolean {
  if (res.idTokenClaims && res.idTokenClaims.roles) {
    const { roles } = res.idTokenClaims;
    return roles.includes("IS24-RO-CustomerPlatform-Engineer") || roles.includes("IS24-RO-Galileo-Engineer");
  }
  return false;
}
